import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'translatedVideoView',
  'lipSyncVideoView',
  'lipsyncVideoCompleted',
  'trialPreviewViewed',
  'trialPreviewEditTranslationButtonClick',
  'trialPreviewPlayingActiveTab',
  'trialPreviewPausedActiveTab',
  'trialPreviewOriginalVideoPlayClick',
  'trialEditorTranslatedVideoPlayClick',
  'trialEditorTranslatedVideoPauseClick',
  'trialEditorOriginalVideoPlayClick',
  'trialEditorOriginalVideoPauseClick',
  'trialPreviewLipSyncUnlockNowClick',
] as const;

export const videoPlayerEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
